//
// Autogenerated by Thrift Compiler (0.10.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
import Thrift from 'thrift';
import CoreMathModel from './core_math_Model_types';
import MoneyModel from './money_Model_types';



var BarProfitToolModel = {};
export default BarProfitToolModel;
BarProfitToolModel.FirstQuestionSetId = function(args) {
  this.value = null;
  if (args) {
    if (args.value !== undefined && args.value !== null) {
      this.value = args.value;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field value is unset!');
    }
  }
};
BarProfitToolModel.FirstQuestionSetId.prototype = {};
BarProfitToolModel.FirstQuestionSetId.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.value = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.FirstQuestionSetId.prototype.write = function(output) {
  output.writeStructBegin('FirstQuestionSetId');
  if (this.value !== null && this.value !== undefined) {
    output.writeFieldBegin('value', Thrift.Type.STRING, 1);
    output.writeString(this.value);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.SecondQuestionSetId = function(args) {
  this.value = null;
  if (args) {
    if (args.value !== undefined && args.value !== null) {
      this.value = args.value;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field value is unset!');
    }
  }
};
BarProfitToolModel.SecondQuestionSetId.prototype = {};
BarProfitToolModel.SecondQuestionSetId.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.value = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.SecondQuestionSetId.prototype.write = function(output) {
  output.writeStructBegin('SecondQuestionSetId');
  if (this.value !== null && this.value !== undefined) {
    output.writeFieldBegin('value', Thrift.Type.STRING, 1);
    output.writeString(this.value);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.SecondAnswerSetId = function(args) {
  this.value = null;
  if (args) {
    if (args.value !== undefined && args.value !== null) {
      this.value = args.value;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field value is unset!');
    }
  }
};
BarProfitToolModel.SecondAnswerSetId.prototype = {};
BarProfitToolModel.SecondAnswerSetId.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.value = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.SecondAnswerSetId.prototype.write = function(output) {
  output.writeStructBegin('SecondAnswerSetId');
  if (this.value !== null && this.value !== undefined) {
    output.writeFieldBegin('value', Thrift.Type.STRING, 1);
    output.writeString(this.value);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.ProductCategoryValues = function(args) {
  this.wine = null;
  this.beer = null;
  this.spirit = null;
  if (args) {
    if (args.wine !== undefined && args.wine !== null) {
      this.wine = args.wine;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field wine is unset!');
    }
    if (args.beer !== undefined && args.beer !== null) {
      this.beer = args.beer;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field beer is unset!');
    }
    if (args.spirit !== undefined && args.spirit !== null) {
      this.spirit = args.spirit;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field spirit is unset!');
    }
  }
};
BarProfitToolModel.ProductCategoryValues.prototype = {};
BarProfitToolModel.ProductCategoryValues.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.I32) {
        this.wine = input.readI32().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.I32) {
        this.beer = input.readI32().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.I32) {
        this.spirit = input.readI32().value;
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.ProductCategoryValues.prototype.write = function(output) {
  output.writeStructBegin('ProductCategoryValues');
  if (this.wine !== null && this.wine !== undefined) {
    output.writeFieldBegin('wine', Thrift.Type.I32, 1);
    output.writeI32(this.wine);
    output.writeFieldEnd();
  }
  if (this.beer !== null && this.beer !== undefined) {
    output.writeFieldBegin('beer', Thrift.Type.I32, 2);
    output.writeI32(this.beer);
    output.writeFieldEnd();
  }
  if (this.spirit !== null && this.spirit !== undefined) {
    output.writeFieldBegin('spirit', Thrift.Type.I32, 3);
    output.writeI32(this.spirit);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.ProductCategoryAndOrTotalValue = function(args) {
  this.productCategoryValues = null;
  this.totalValue = null;
  if (args) {
    if (args.productCategoryValues !== undefined && args.productCategoryValues !== null) {
      this.productCategoryValues = new BarProfitToolModel.ProductCategoryValues(args.productCategoryValues);
    }
    if (args.totalValue !== undefined && args.totalValue !== null) {
      this.totalValue = args.totalValue;
    }
  }
};
BarProfitToolModel.ProductCategoryAndOrTotalValue.prototype = {};
BarProfitToolModel.ProductCategoryAndOrTotalValue.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.productCategoryValues = new BarProfitToolModel.ProductCategoryValues();
        this.productCategoryValues.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.I32) {
        this.totalValue = input.readI32().value;
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.ProductCategoryAndOrTotalValue.prototype.write = function(output) {
  output.writeStructBegin('ProductCategoryAndOrTotalValue');
  if (this.productCategoryValues !== null && this.productCategoryValues !== undefined) {
    output.writeFieldBegin('productCategoryValues', Thrift.Type.STRUCT, 1);
    this.productCategoryValues.write(output);
    output.writeFieldEnd();
  }
  if (this.totalValue !== null && this.totalValue !== undefined) {
    output.writeFieldBegin('totalValue', Thrift.Type.I32, 2);
    output.writeI32(this.totalValue);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.SecondAnswerSet = function(args) {
  this.currency = null;
  this.averageSittingInventoryInCurrency = null;
  this.annualSalesInCurrency = null;
  this.pourCostPerMille = null;
  if (args) {
    if (args.currency !== undefined && args.currency !== null) {
      this.currency = args.currency;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field currency is unset!');
    }
    if (args.averageSittingInventoryInCurrency !== undefined && args.averageSittingInventoryInCurrency !== null) {
      this.averageSittingInventoryInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue(args.averageSittingInventoryInCurrency);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field averageSittingInventoryInCurrency is unset!');
    }
    if (args.annualSalesInCurrency !== undefined && args.annualSalesInCurrency !== null) {
      this.annualSalesInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue(args.annualSalesInCurrency);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field annualSalesInCurrency is unset!');
    }
    if (args.pourCostPerMille !== undefined && args.pourCostPerMille !== null) {
      this.pourCostPerMille = new BarProfitToolModel.ProductCategoryAndOrTotalValue(args.pourCostPerMille);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field pourCostPerMille is unset!');
    }
  }
};
BarProfitToolModel.SecondAnswerSet.prototype = {};
BarProfitToolModel.SecondAnswerSet.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.I32) {
        this.currency = input.readI32().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.averageSittingInventoryInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue();
        this.averageSittingInventoryInCurrency.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.annualSalesInCurrency = new BarProfitToolModel.ProductCategoryAndOrTotalValue();
        this.annualSalesInCurrency.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.pourCostPerMille = new BarProfitToolModel.ProductCategoryAndOrTotalValue();
        this.pourCostPerMille.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.SecondAnswerSet.prototype.write = function(output) {
  output.writeStructBegin('SecondAnswerSet');
  if (this.currency !== null && this.currency !== undefined) {
    output.writeFieldBegin('currency', Thrift.Type.I32, 1);
    output.writeI32(this.currency);
    output.writeFieldEnd();
  }
  if (this.averageSittingInventoryInCurrency !== null && this.averageSittingInventoryInCurrency !== undefined) {
    output.writeFieldBegin('averageSittingInventoryInCurrency', Thrift.Type.STRUCT, 2);
    this.averageSittingInventoryInCurrency.write(output);
    output.writeFieldEnd();
  }
  if (this.annualSalesInCurrency !== null && this.annualSalesInCurrency !== undefined) {
    output.writeFieldBegin('annualSalesInCurrency', Thrift.Type.STRUCT, 3);
    this.annualSalesInCurrency.write(output);
    output.writeFieldEnd();
  }
  if (this.pourCostPerMille !== null && this.pourCostPerMille !== undefined) {
    output.writeFieldBegin('pourCostPerMille', Thrift.Type.STRUCT, 4);
    this.pourCostPerMille.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.RelevantPoints = function(args) {
  this.min = null;
  this.firstQuartile = null;
  this.median = null;
  this.thirdQuartile = null;
  this.max = null;
  this.you = null;
  if (args) {
    if (args.min !== undefined && args.min !== null) {
      this.min = new CoreMathModel.Decimal(args.min);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field min is unset!');
    }
    if (args.firstQuartile !== undefined && args.firstQuartile !== null) {
      this.firstQuartile = new CoreMathModel.Decimal(args.firstQuartile);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field firstQuartile is unset!');
    }
    if (args.median !== undefined && args.median !== null) {
      this.median = new CoreMathModel.Decimal(args.median);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field median is unset!');
    }
    if (args.thirdQuartile !== undefined && args.thirdQuartile !== null) {
      this.thirdQuartile = new CoreMathModel.Decimal(args.thirdQuartile);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field thirdQuartile is unset!');
    }
    if (args.max !== undefined && args.max !== null) {
      this.max = new CoreMathModel.Decimal(args.max);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field max is unset!');
    }
    if (args.you !== undefined && args.you !== null) {
      this.you = new CoreMathModel.Decimal(args.you);
    }
  }
};
BarProfitToolModel.RelevantPoints.prototype = {};
BarProfitToolModel.RelevantPoints.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.min = new CoreMathModel.Decimal();
        this.min.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.firstQuartile = new CoreMathModel.Decimal();
        this.firstQuartile.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.median = new CoreMathModel.Decimal();
        this.median.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.thirdQuartile = new CoreMathModel.Decimal();
        this.thirdQuartile.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 5:
      if (ftype == Thrift.Type.STRUCT) {
        this.max = new CoreMathModel.Decimal();
        this.max.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 6:
      if (ftype == Thrift.Type.STRUCT) {
        this.you = new CoreMathModel.Decimal();
        this.you.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.RelevantPoints.prototype.write = function(output) {
  output.writeStructBegin('RelevantPoints');
  if (this.min !== null && this.min !== undefined) {
    output.writeFieldBegin('min', Thrift.Type.STRUCT, 1);
    this.min.write(output);
    output.writeFieldEnd();
  }
  if (this.firstQuartile !== null && this.firstQuartile !== undefined) {
    output.writeFieldBegin('firstQuartile', Thrift.Type.STRUCT, 2);
    this.firstQuartile.write(output);
    output.writeFieldEnd();
  }
  if (this.median !== null && this.median !== undefined) {
    output.writeFieldBegin('median', Thrift.Type.STRUCT, 3);
    this.median.write(output);
    output.writeFieldEnd();
  }
  if (this.thirdQuartile !== null && this.thirdQuartile !== undefined) {
    output.writeFieldBegin('thirdQuartile', Thrift.Type.STRUCT, 4);
    this.thirdQuartile.write(output);
    output.writeFieldEnd();
  }
  if (this.max !== null && this.max !== undefined) {
    output.writeFieldBegin('max', Thrift.Type.STRUCT, 5);
    this.max.write(output);
    output.writeFieldEnd();
  }
  if (this.you !== null && this.you !== undefined) {
    output.writeFieldBegin('you', Thrift.Type.STRUCT, 6);
    this.you.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.ReportSet = function(args) {
  this.wine = null;
  this.beer = null;
  this.spirits = null;
  this.total = null;
  if (args) {
    if (args.wine !== undefined && args.wine !== null) {
      this.wine = new BarProfitToolModel.RelevantPoints(args.wine);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field wine is unset!');
    }
    if (args.beer !== undefined && args.beer !== null) {
      this.beer = new BarProfitToolModel.RelevantPoints(args.beer);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field beer is unset!');
    }
    if (args.spirits !== undefined && args.spirits !== null) {
      this.spirits = new BarProfitToolModel.RelevantPoints(args.spirits);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field spirits is unset!');
    }
    if (args.total !== undefined && args.total !== null) {
      this.total = new BarProfitToolModel.RelevantPoints(args.total);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field total is unset!');
    }
  }
};
BarProfitToolModel.ReportSet.prototype = {};
BarProfitToolModel.ReportSet.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.wine = new BarProfitToolModel.RelevantPoints();
        this.wine.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.beer = new BarProfitToolModel.RelevantPoints();
        this.beer.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.spirits = new BarProfitToolModel.RelevantPoints();
        this.spirits.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.total = new BarProfitToolModel.RelevantPoints();
        this.total.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.ReportSet.prototype.write = function(output) {
  output.writeStructBegin('ReportSet');
  if (this.wine !== null && this.wine !== undefined) {
    output.writeFieldBegin('wine', Thrift.Type.STRUCT, 1);
    this.wine.write(output);
    output.writeFieldEnd();
  }
  if (this.beer !== null && this.beer !== undefined) {
    output.writeFieldBegin('beer', Thrift.Type.STRUCT, 2);
    this.beer.write(output);
    output.writeFieldEnd();
  }
  if (this.spirits !== null && this.spirits !== undefined) {
    output.writeFieldBegin('spirits', Thrift.Type.STRUCT, 3);
    this.spirits.write(output);
    output.writeFieldEnd();
  }
  if (this.total !== null && this.total !== undefined) {
    output.writeFieldBegin('total', Thrift.Type.STRUCT, 4);
    this.total.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.ReportAnalysis = function(args) {
  this.classId = null;
  this.shortDescription = null;
  this.summary = null;
  this.recommendations = null;
  if (args) {
    if (args.classId !== undefined && args.classId !== null) {
      this.classId = args.classId;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field classId is unset!');
    }
    if (args.shortDescription !== undefined && args.shortDescription !== null) {
      this.shortDescription = args.shortDescription;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field shortDescription is unset!');
    }
    if (args.summary !== undefined && args.summary !== null) {
      this.summary = args.summary;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field summary is unset!');
    }
    if (args.recommendations !== undefined && args.recommendations !== null) {
      this.recommendations = Thrift.copyList(args.recommendations, [null]);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field recommendations is unset!');
    }
  }
};
BarProfitToolModel.ReportAnalysis.prototype = {};
BarProfitToolModel.ReportAnalysis.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.classId = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRING) {
        this.shortDescription = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRING) {
        this.summary = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.LIST) {
        var _size0 = 0;
        var _rtmp34;
        this.recommendations = [];
        var _etype3 = 0;
        _rtmp34 = input.readListBegin();
        _etype3 = _rtmp34.etype;
        _size0 = _rtmp34.size;
        for (var _i5 = 0; _i5 < _size0; ++_i5)
        {
          var elem6 = null;
          elem6 = input.readString().value;
          this.recommendations.push(elem6);
        }
        input.readListEnd();
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.ReportAnalysis.prototype.write = function(output) {
  output.writeStructBegin('ReportAnalysis');
  if (this.classId !== null && this.classId !== undefined) {
    output.writeFieldBegin('classId', Thrift.Type.STRING, 1);
    output.writeString(this.classId);
    output.writeFieldEnd();
  }
  if (this.shortDescription !== null && this.shortDescription !== undefined) {
    output.writeFieldBegin('shortDescription', Thrift.Type.STRING, 2);
    output.writeString(this.shortDescription);
    output.writeFieldEnd();
  }
  if (this.summary !== null && this.summary !== undefined) {
    output.writeFieldBegin('summary', Thrift.Type.STRING, 3);
    output.writeString(this.summary);
    output.writeFieldEnd();
  }
  if (this.recommendations !== null && this.recommendations !== undefined) {
    output.writeFieldBegin('recommendations', Thrift.Type.LIST, 4);
    output.writeListBegin(Thrift.Type.STRING, this.recommendations.length);
    for (var iter7 in this.recommendations)
    {
      if (this.recommendations.hasOwnProperty(iter7))
      {
        iter7 = this.recommendations[iter7];
        output.writeString(iter7);
      }
    }
    output.writeListEnd();
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

BarProfitToolModel.Report = function(args) {
  this.letterGrade = null;
  this.averageSittingInventory = null;
  this.annualSales = null;
  this.pourCostPercent = null;
  this.inventoryWeeks = null;
  this.weeklyUsage = null;
  this.pourCostPercentAnalysis = null;
  this.inventoryWeeksAnalysis = null;
  if (args) {
    if (args.letterGrade !== undefined && args.letterGrade !== null) {
      this.letterGrade = args.letterGrade;
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field letterGrade is unset!');
    }
    if (args.averageSittingInventory !== undefined && args.averageSittingInventory !== null) {
      this.averageSittingInventory = new BarProfitToolModel.ReportSet(args.averageSittingInventory);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field averageSittingInventory is unset!');
    }
    if (args.annualSales !== undefined && args.annualSales !== null) {
      this.annualSales = new BarProfitToolModel.ReportSet(args.annualSales);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field annualSales is unset!');
    }
    if (args.pourCostPercent !== undefined && args.pourCostPercent !== null) {
      this.pourCostPercent = new BarProfitToolModel.ReportSet(args.pourCostPercent);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field pourCostPercent is unset!');
    }
    if (args.inventoryWeeks !== undefined && args.inventoryWeeks !== null) {
      this.inventoryWeeks = new BarProfitToolModel.ReportSet(args.inventoryWeeks);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field inventoryWeeks is unset!');
    }
    if (args.weeklyUsage !== undefined && args.weeklyUsage !== null) {
      this.weeklyUsage = new BarProfitToolModel.ReportSet(args.weeklyUsage);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field weeklyUsage is unset!');
    }
    if (args.pourCostPercentAnalysis !== undefined && args.pourCostPercentAnalysis !== null) {
      this.pourCostPercentAnalysis = new BarProfitToolModel.ReportAnalysis(args.pourCostPercentAnalysis);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field pourCostPercentAnalysis is unset!');
    }
    if (args.inventoryWeeksAnalysis !== undefined && args.inventoryWeeksAnalysis !== null) {
      this.inventoryWeeksAnalysis = new BarProfitToolModel.ReportAnalysis(args.inventoryWeeksAnalysis);
    } else {
      throw new Thrift.TProtocolException(Thrift.TProtocolExceptionType.UNKNOWN, 'Required field inventoryWeeksAnalysis is unset!');
    }
  }
};
BarProfitToolModel.Report.prototype = {};
BarProfitToolModel.Report.prototype.read = function(input) {
  input.readStructBegin();
  while (true)
  {
    var ret = input.readFieldBegin();
    var fname = ret.fname;
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid)
    {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.letterGrade = input.readString().value;
      } else {
        input.skip(ftype);
      }
      break;
      case 2:
      if (ftype == Thrift.Type.STRUCT) {
        this.averageSittingInventory = new BarProfitToolModel.ReportSet();
        this.averageSittingInventory.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 3:
      if (ftype == Thrift.Type.STRUCT) {
        this.annualSales = new BarProfitToolModel.ReportSet();
        this.annualSales.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 4:
      if (ftype == Thrift.Type.STRUCT) {
        this.pourCostPercent = new BarProfitToolModel.ReportSet();
        this.pourCostPercent.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 5:
      if (ftype == Thrift.Type.STRUCT) {
        this.inventoryWeeks = new BarProfitToolModel.ReportSet();
        this.inventoryWeeks.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 6:
      if (ftype == Thrift.Type.STRUCT) {
        this.weeklyUsage = new BarProfitToolModel.ReportSet();
        this.weeklyUsage.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 7:
      if (ftype == Thrift.Type.STRUCT) {
        this.pourCostPercentAnalysis = new BarProfitToolModel.ReportAnalysis();
        this.pourCostPercentAnalysis.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 8:
      if (ftype == Thrift.Type.STRUCT) {
        this.inventoryWeeksAnalysis = new BarProfitToolModel.ReportAnalysis();
        this.inventoryWeeksAnalysis.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

BarProfitToolModel.Report.prototype.write = function(output) {
  output.writeStructBegin('Report');
  if (this.letterGrade !== null && this.letterGrade !== undefined) {
    output.writeFieldBegin('letterGrade', Thrift.Type.STRING, 1);
    output.writeString(this.letterGrade);
    output.writeFieldEnd();
  }
  if (this.averageSittingInventory !== null && this.averageSittingInventory !== undefined) {
    output.writeFieldBegin('averageSittingInventory', Thrift.Type.STRUCT, 2);
    this.averageSittingInventory.write(output);
    output.writeFieldEnd();
  }
  if (this.annualSales !== null && this.annualSales !== undefined) {
    output.writeFieldBegin('annualSales', Thrift.Type.STRUCT, 3);
    this.annualSales.write(output);
    output.writeFieldEnd();
  }
  if (this.pourCostPercent !== null && this.pourCostPercent !== undefined) {
    output.writeFieldBegin('pourCostPercent', Thrift.Type.STRUCT, 4);
    this.pourCostPercent.write(output);
    output.writeFieldEnd();
  }
  if (this.inventoryWeeks !== null && this.inventoryWeeks !== undefined) {
    output.writeFieldBegin('inventoryWeeks', Thrift.Type.STRUCT, 5);
    this.inventoryWeeks.write(output);
    output.writeFieldEnd();
  }
  if (this.weeklyUsage !== null && this.weeklyUsage !== undefined) {
    output.writeFieldBegin('weeklyUsage', Thrift.Type.STRUCT, 6);
    this.weeklyUsage.write(output);
    output.writeFieldEnd();
  }
  if (this.pourCostPercentAnalysis !== null && this.pourCostPercentAnalysis !== undefined) {
    output.writeFieldBegin('pourCostPercentAnalysis', Thrift.Type.STRUCT, 7);
    this.pourCostPercentAnalysis.write(output);
    output.writeFieldEnd();
  }
  if (this.inventoryWeeksAnalysis !== null && this.inventoryWeeksAnalysis !== undefined) {
    output.writeFieldBegin('inventoryWeeksAnalysis', Thrift.Type.STRUCT, 8);
    this.inventoryWeeksAnalysis.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

